"use strict";

var _regeneratorRuntime = require("/builds/sites/ondacero-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = exports.removeValueSession = exports.isMobile = exports.isAppMeasurementLoaded = exports.is404 = exports.getValueSession = exports.getUrlFormated = exports.getTypePage = exports.getTime = exports.getPath = exports.getOS = exports.getMeta = exports.getDate = exports.getCookie = exports.getCampaignParams = exports.assignUserId = exports.addZero = void 0;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
/**
 * Devuelve la url formateada en funcion de los niveles indicados. Si no se indica nivel devuelve toda la url formateada.
 *
 * @param {string} url
 * @param {string} regex
 * @param {number} level
 */


var getPath = function getPath(url, regex, depth) {
  var levels = url.split('/');

  if (depth) {
    return levels[depth - 1] ? levels.slice(0, depth).join(regex) : undefined;
  }

  return levels.join(regex);
};
/**
 * Obtiene en contenido del <Meta> a través de su nombre o propiedad
 *
 * @param {string} value
 */


exports.getPath = getPath;

var getMeta = function getMeta(value) {
  var content;
  var metaName = document.querySelector("meta[name=\"".concat(value, "\"]"));

  if (metaName) {
    content = metaName.getAttribute('content');
  }

  var metaProperty = document.querySelector("meta[property=\"".concat(value, "\"]"));

  if (metaProperty) {
    content = metaProperty.getAttribute('content');
  }

  return content || undefined;
};

exports.getMeta = getMeta;

var addZero = function addZero(num) {
  return num < 10 ? "0".concat(num) : num;
};
/**
 * Se obtiene la fecha en formato YYYYMMDD
 *
 * @param {string} time
 */


exports.addZero = addZero;

var getDate = function getDate(time) {
  if (time) {
    var datetime = new Date(time);
    var year = datetime.getFullYear();
    var month = addZero(datetime.getMonth() + 1);
    var day = addZero(datetime.getDate());
    return "".concat(day).concat(month).concat(year);
  }

  return undefined;
};
/**
 * Se obtiene la hora en formato HH:MM
 *
 * @param {string} time
 */


exports.getDate = getDate;

var getTime = function getTime(time) {
  if (time) {
    var datetime = new Date(time);
    var hours = addZero(datetime.getHours() + 1);
    var minutes = addZero(datetime.getMinutes());
    return "".concat(hours, ":").concat(minutes);
  }

  return undefined;
};
/**
 * Tipo de dispositivo al que se acced
 */


exports.getTime = getTime;

var isMobile = function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
/**
 * Obtiene el tipo de página
 *
 * @param {string} section
 * @param {string} url
 */


exports.isMobile = isMobile;

var getTypePage = function getTypePage(section, url) {
  if (section) {
    if (url.endsWith('/')) {
      return 'categoria';
    }

    if (url.includes('/temas/')) {
      return 'tag';
    }

    return 'contenido';
  }

  return 'home';
};

exports.getTypePage = getTypePage;

var isAppMeasurementLoaded = function isAppMeasurementLoaded() {
  return new Promise(function (resolve, reject) {
    var counter = 0;
    var attempts = 100;
    var range = 100;
    var interval = setInterval(function () {
      if (counter >= attempts) {
        clearInterval(interval);
        reject();
      }

      if (window && typeof window.s !== 'undefined') {
        clearInterval(interval);
        resolve(true);
      } else {
        counter += 1;
      }
    }, range);
  });
};

exports.isAppMeasurementLoaded = isAppMeasurementLoaded;

var getCampaignParams = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var TCode, isLoaded, _window, s, TCfinal;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(window.globalConfig && window.globalConfig.skipCampaignParams)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", undefined);

          case 2:
            TCode = [];
            isLoaded = window && window.s;

            if (isLoaded) {
              _context.next = 8;
              break;
            }

            _context.next = 7;
            return isAppMeasurementLoaded();

          case 7:
            isLoaded = _context.sent;

          case 8:
            if (!isLoaded) {
              _context.next = 13;
              break;
            }

            _window = window, s = _window.s; // meto cada parámetro de la query en el vector TCode

            if (s.Util.getQueryParam('site') !== '' || s.Util.getQueryParam('campaign') !== '' || s.Util.getQueryParam('promo') !== '' || s.Util.getQueryParam('formato') !== '') {
              TCode.push(s.Util.getQueryParam('site'));
              TCode.push(s.Util.getQueryParam('campaign'));
              TCode.push(s.Util.getQueryParam('promo'));
              TCode.push(s.Util.getQueryParam('formato'));
            } else {
              TCode.push(s.Util.getQueryParam('k'));
              TCode.push(s.Util.getQueryParam('r'));
              TCode.push(s.Util.getQueryParam('er'));
              TCode.push(s.Util.getQueryParam('d'));
              TCode.push(s.Util.getQueryParam('t'));
              TCode.push(s.Util.getQueryParam('ui'));
              TCode.push(s.Util.getQueryParam('us'));
              TCode.push(s.Util.getQueryParam('tp'));
              TCode.push(s.Util.getQueryParam('wd'));
              TCode.push(s.Util.getQueryParam('dp'));
              TCode.push(s.Util.getQueryParam('so'));
              TCode.push(s.Util.getQueryParam('sp'));
              TCode.push(s.Util.getQueryParam('sem'));
              TCode.push(s.Util.getQueryParam('sem'));
              TCode.push(s.Util.getQueryParam('sms'));
              TCode.push(s.Util.getQueryParam('dis'));
              TCode.push(s.Util.getQueryParam('rtb'));
              TCode.push(s.Util.getQueryParam('eml'));
              TCode.push(s.Util.getQueryParam('ps'));
              TCode.push(s.Util.getQueryParam('ic'));
              TCode.push(s.Util.getQueryParam('oi'));
              TCode.push(s.Util.getQueryParam('oe'));
              TCode.push(s.Util.getQueryParam('oa'));
              TCode.push(s.Util.getQueryParam('op'));
              TCode.push(s.Util.getQueryParam('ex'));
              TCode.push(s.Util.getQueryParam('sour'));
              TCode.push(s.Util.getQueryParam('pm'));
              TCode.push(s.Util.getQueryParam('cn'));
              TCode.push(s.Util.getQueryParam('kw'));
              TCode.push(s.Util.getQueryParam('sd'));
              TCode.push(s.Util.getQueryParam('em'));
              TCode.push(s.Util.getQueryParam('c'));
              TCode.push(s.Util.getQueryParam('spro'));
              TCode.push(s.Util.getQueryParam('npro'));
              TCode.push(s.Util.getQueryParam('f'));
              TCode.push(s.Util.getQueryParam('s'));
              TCode.push(s.Util.getQueryParam('pr'));
            }

            TCfinal = TCode.join(':');
            return _context.abrupt("return", TCfinal.search(/[A-Za-z]/) !== -1 ? TCfinal : undefined);

          case 13:
            return _context.abrupt("return", undefined);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCampaignParams() {
    return _ref.apply(this, arguments);
  };
}();

exports.getCampaignParams = getCampaignParams;

var getOS = function getOS() {
  var nAgt = navigator.userAgent;
  var clientStrings = [{
    s: 'Windows 10',
    r: /(Windows 10.0|Windows NT 10.0)/
  }, {
    s: 'Windows 8.1',
    r: /(Windows 8.1|Windows NT 6.3)/
  }, {
    s: 'Windows 8',
    r: /(Windows 8|Windows NT 6.2)/
  }, {
    s: 'Windows 7',
    r: /(Windows 7|Windows NT 6.1)/
  }, {
    s: 'Windows Vista',
    r: /Windows NT 6.0/
  }, {
    s: 'Windows Server 2003',
    r: /Windows NT 5.2/
  }, {
    s: 'Windows XP',
    r: /(Windows NT 5.1|Windows XP)/
  }, {
    s: 'Windows 2000',
    r: /(Windows NT 5.0|Windows 2000)/
  }, {
    s: 'Windows ME',
    r: /(Win 9x 4.90|Windows ME)/
  }, {
    s: 'Windows 98',
    r: /(Windows 98|Win98)/
  }, {
    s: 'Windows 95',
    r: /(Windows 95|Win95|Windows_95)/
  }, {
    s: 'Windows NT 4.0',
    r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
  }, {
    s: 'Windows CE',
    r: /Windows CE/
  }, {
    s: 'Windows 3.11',
    r: /Win16/
  }, {
    s: 'Android',
    r: /Android/
  }, {
    s: 'Open BSD',
    r: /OpenBSD/
  }, {
    s: 'Sun OS',
    r: /SunOS/
  }, {
    s: 'Chrome OS',
    r: /CrOS/
  }, {
    s: 'Linux',
    r: /(Linux|X11(?!.*CrOS))/
  }, {
    s: 'iOS',
    r: /(iPhone|iPad|iPod)/
  }, {
    s: 'Mac OS X',
    r: /Mac OS X/
  }, {
    s: 'Mac OS',
    r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
  }, {
    s: 'QNX',
    r: /QNX/
  }, {
    s: 'UNIX',
    r: /UNIX/
  }, {
    s: 'BeOS',
    r: /BeOS/
  }, {
    s: 'OS/2',
    r: /OS\/2/
  }, {
    s: 'Search Bot',
    r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
  }];
  var currentSO = clientStrings.find(function (cs) {
    return cs.r.test(nAgt);
  });
  return currentSO ? currentSO.s : 'Unknown OS';
};

exports.getOS = getOS;
var nameStorageUserId = 'userid_datalayer';

var assignUserId = function assignUserId() {
  var _window2 = window,
      localStorage = _window2.localStorage;

  if (localStorage && typeof localStorage !== 'undefined') {
    var storageUserId = localStorage.getItem(nameStorageUserId);

    if (!storageUserId) {
      var randomIdUser = Math.floor((1 + Math.random()) * 0x100000000000).toString(16).substring(1);
      localStorage.setItem(nameStorageUserId, randomIdUser);
      return randomIdUser;
    }

    return storageUserId;
  }

  return undefined;
};

exports.assignUserId = assignUserId;

var is404 = function is404() {
  return document.getElementsByClassName('mod-404').length > 0 || document.getElementsByClassName('error404').length > 0 || document.getElementsByClassName('error-page-header').length > 0 ? '404' : undefined;
};

exports.is404 = is404;

var setCookie = function setCookie(name, value, days) {
  var expires = '';

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=".concat(date.toUTCString());
  }

  document.cookie = "".concat(name, "=").concat(value || '').concat(expires, "; path=/");
};

exports.setCookie = setCookie;

var getCookie = function getCookie(name) {
  var value = document.cookie;
  var cookieName = "".concat(name, "=");
  var response;

  if (value.includes(cookieName)) {
    var parts = value.split(cookieName);
    var cookieResponse = parts[parts.length - 1].split(";");
    response = "".concat(cookieResponse[0]);
  }

  return response;
};

exports.getCookie = getCookie;

var getUrlFormated = function getUrlFormated(url) {
  return url.split('/').join(':');
};

exports.getUrlFormated = getUrlFormated;

var getValueSession = function getValueSession(key) {
  if (sessionStorage && typeof sessionStorage !== 'undefined') {
    return window.sessionStorage.getItem(key);
  }

  return undefined;
};

exports.getValueSession = getValueSession;

var removeValueSession = function removeValueSession(key) {
  if (sessionStorage && typeof sessionStorage !== 'undefined') {
    return window.sessionStorage.removeItem(key);
  }

  return undefined;
};

exports.removeValueSession = removeValueSession;